export default __webpack_public_path__ + "img/bg-c605cee3.png";